import { getAttrValue } from "@grandvisionhq/utils";
const getNameFromVariant = (variant) => {
  const brand = getAttrValue(variant, "brand");
  const brandModel = getAttrValue(variant, "brandModel");
  const brandModelCode = getAttrValue(variant, "brandModelCode");
  const name = [...new Set([brand, brandModel, brandModelCode].filter(Boolean))].join(" ").trim();
  return name;
};
const transformValue = (data, locale) => data.filter((item) => item[locale] || item[locale.substring(0, 2)]).reduce((_, next) => {
  const localeValue = next[locale];
  const fallbackValue = next[locale.substring(0, 2)];
  return localeValue || fallbackValue || "";
}, "");
const formatAttribute = (attributes) => ({
  [attributes.locale]: attributes.value
});
const formatAttributes = (attributes) => ({
  [attributes.locale]: attributes.values.join(",")
});
const transformToEventPayload = ({
  dimension147,
  dimension16,
  dimension146,
  variant,
  locale
}) => {
  return {
    variant: variant ? transformValue(variant, locale) : "",
    dimension16: dimension16 ? transformValue(dimension16, locale).toLowerCase() : "",
    dimension146: dimension146 ? transformValue(dimension146, locale) : "",
    dimension147: dimension147 ? transformValue(dimension147, locale) : ""
  };
};
export {
  formatAttribute,
  formatAttributes,
  getNameFromVariant,
  transformToEventPayload,
  transformValue
};
//# sourceMappingURL=utils.js.map
